import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DateRangePicker, Calendar } from 'react-date-range';
import { defaultStaticRanges } from './defaultRanges';
import { startOfMonth, endOfMonth, addMonths, format, parseISO, isAfter, isBefore, startOfToday, subYears } from 'date-fns';
import { actions as filterActions } from '../../../redux/reducers/filterReducer';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import CustomButton from '../customButton';
import { Box, Typography } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { BAVENCIO_COMPANY_ID } from '../../../constants';

const MAX_RANGE_RESTRICTED_COMPANY_IDS = [BAVENCIO_COMPANY_ID];

function CustomCalendar(props) {
    const {
        ranges, handleDateRange, onSubmit, closeModal, ...rest 
    } = props;
    const dispatch = useDispatch();
    const { startDateRange, endDateRange } = useSelector((state) => state.filter);
    const { company } = useSelector((state) => state.company);
    const { setDateRange } = filterActions;
    const isMaxRangeRestricted = MAX_RANGE_RESTRICTED_COMPANY_IDS.includes(company?.id);
    const minAllowedDate = isMaxRangeRestricted ? subYears(new Date(), 1) : undefined;
    const staticRanges = isMaxRangeRestricted
        ? defaultStaticRanges.filter((range) => !['Last 2 Years', 'Last 3 Years'].includes(range.label))
        : defaultStaticRanges;
    const [selectedDateRange, setSelectedDateRange] = useState({
        startDate: parseISO(startDateRange),
        endDate: parseISO(endDateRange),
        key: 'selection'
    });
    const handleSelect = (ranges) => {
        const { startDate, endDate } = ranges.selection;
        setSelectedDateRange({
            startDate,
            endDate,
            key: 'selection'
        });
    };

    const onClickDone = () => {
        const todayDate = new Date();
        const todayStartDate = new Date(todayDate.getFullYear(), todayDate.getMonth(), todayDate.getDate());
        let selectedStartDate = new Date(
            selectedDateRange.startDate.getFullYear(), selectedDateRange.startDate.getMonth(), selectedDateRange.startDate.getDate()
        );
        const selectedEndDate = new Date(
            selectedDateRange.endDate.getFullYear(), selectedDateRange.endDate.getMonth(), selectedDateRange.endDate.getDate()
        );
        if (minAllowedDate && isBefore(selectedStartDate, minAllowedDate)) {
            selectedStartDate = minAllowedDate;
        }
        if (isAfter(selectedStartDate, todayStartDate) || isAfter(selectedEndDate, todayStartDate)) {
            const startRange = format(selectedStartDate, 'yyyy-MM-dd');
            const endRange = format(todayStartDate, 'yyyy-MM-dd');
            dispatch(setDateRange({ startDate: startRange, endDate: endRange }));
            closeModal();
            handleDateRange();
        } else {
            const startRange = format(selectedStartDate, 'yyyy-MM-dd');
            const endRange = format(selectedDateRange.endDate, 'yyyy-MM-dd');
            dispatch(setDateRange({ startDate: startRange, endDate: endRange }));
            closeModal();
            handleDateRange();
        }
    };

    const onClickClear = () => {
        setSelectedDateRange({
            startDate: new Date(),
            endDate: new Date(),
            key: 'selection'
        });
    };

    return (
        <div className="shadow d-inline-block bg-white">
            <DateRangePicker
                direction="horizontal"
                editableDateInputs={true}
                inputRanges={[]}
                maxDate={new Date()}
                minDate={minAllowedDate}
                months={2}
                moveRangeOnFirstSelection={false}
                rangeColors={['#ae5da5', '#ae5da5', '#ae5da5']}
                ranges={[selectedDateRange]}
                retainEndDateOnFirstSelection={true}
                showSelectionPreview={true}
                staticRanges={staticRanges}
                onChange={handleSelect}
            />

            <div className="d-flex flex-row gap-12 padding-tb-16-rl-24">
                <Box>
                    <Typography className='d-flex flex-row align-items-center gap-12' color="warning.main" variant="subtitle2" width={'80%'}>
                        <ErrorOutlineIcon/>The selected dates cannot be in the future. So please always choose a valid date.
                    </Typography>
                </Box >
                <Box className="d-flex flex-row gap-12 ml-auto">
                    <CustomButton
                        buttonColor="#AD509E"
                        handleClick={onClickDone}
                        title="Apply"
                        titleColor="#FFFFFF"
                    />
                    <CustomButton
                        buttonColor="#FFFFFF"
                        handleClick={closeModal}
                        title="Cancel"
                        titleColor="#344054"
                    />
                </Box>

            </div>
        </div>
    );
}

CustomCalendar.defaultProps = {
    ranges: defaultStaticRanges,
    handleDateRange: () => {}
};

export default CustomCalendar;
